import React from 'react';

import { Switch, Route } from 'react-router-dom';

import TablaInvoice from './tablaInvoice.js'
import InvoiceForm from './invoiceForm.js'
import Importacion from './importacion.js'
import ReposteFacturasDia from './FacturasDia.js'

export default (props) => {
    return(
        <Switch>
            <Route exact path='/invoiceModule' component={TablaInvoice} />
            <Route exact path='/invoiceModule/reporte/facturas_dia' component={ReposteFacturasDia} />
            <Route exact path='/invoiceModule/form' component={InvoiceForm} />
            <Route exact path='/invoiceModule/edit/:id' component={InvoiceForm} />
            <Route exact path='/invoiceModule/importar' component={Importacion} />
            <Route exact path='/invoiceModule/importar/:id' component={Importacion} />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/views/facturacion/invoiceModule/index.js